(function (algolia) {
  'use strict';

  var enabled = algolia.config.analytics_enabled;
  if (!enabled) return;

  !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e.aa=e.aa||function(){(e.aa.queue=e.aa.queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],i.async=1,i.src="https://cdn.jsdelivr.net/npm/search-insights@0.0.14",c.parentNode.insertBefore(i,c)}(window,document,"script",0,"aa");

  aa('init', {
    applicationID: algolia.config.app_id,
    apiKey: algolia.config.search_api_key
  })

  // Track CTR for products
  algolia.clickTracker = function (object) {

    // Get the data from the product that was clicked
    const data = {
      objectID: object.getAttribute('data-algolia-objectid'),
      position: parseInt(object.getAttribute('data-algolia-position')),
      queryID: object.getAttribute('data-algolia-queryid')
    };

    // Track the CTR for that product
    window.aa('click', data);

    // Try to save the details in local storage for conversion tracking.
    // We're using a try, catch here to handle any possible exceptions
    // resulting from local storage or JSON parsing.
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem('algolia_analytics_clicked_objects') || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);
      // Add the current products data to local storage
      previousClickItems.push(data)
      localStorage.setItem('algolia_analytics_clicked_objects', JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  }



  // Track conversion rates for products
  window.algolia_conversionTracker = algolia.conversionTracker = function () {
    // Try to get the details from local storage for conversion tracking.
    // We're using a try, catch here to handle any possible exceptions
    // resulting from local storage or JSON parsing.
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem('algolia_analytics_clicked_objects');

      // If data was found, track conversion on all those products
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString);

        // Createur: If they're in the order.
        previousClickItems = previousClickItems.filter(item => cartVariants.indexOf(item.objectID) !== -1);

        previousClickItems.forEach(data => {
          if (!!data.objectID && !!data.queryID) {
            window.aa('conversion', { objectID: data.objectID, queryID: data.queryID });
          }
        })
      }
    } catch (error) {
      // No need to do anything in this scenario
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem('algolia_analytics_clicked_objects');
    } catch (error) {
      // No need to do anything in this scenario
    }
  }


}(algoliaShopify));